import React from "react";
import Badge1 from "./image/badge(1).png"
import "./about.css"
import Badge from "./image/badge.png";
import { FaGithub } from 'react-icons/fa';
import { Container, Row, Col } from "react-bootstrap";
import Resume from "./resume";
import EU from "./image/erusmus.png";
import MIST from "./image/MIST.png";
import DCC from "./image/DCC.png";
import AK from "./image/AKK.png"
import Cap from "./image/cap.png"
import IFROS from "./image/IFROS.png"

export default function AboutMobileBody() {

   
    return (

        <div className="AboutMobileBody">
  <p className="about-header" ><b>About Me</b></p>
            <Container>
             

                <div className="content-container">
              
       

                
               
                        <h className="tabs-list">Technical Skills</h>
                    
                        {/* <p>  <h style={{ color: "#bcc4b7" }}> MS Office </h>: MS Word, MS PowerPoint, MS Excel</p>
                        <p> <h style={{ color: "#bcc4b7" }}> Programming Languages</h>: Python, C, MATLAB, Dart,
                            JavaScript, Verilog HDL</p>
                        <p>
                            <h style={{ color: "#bcc4b7" }}>Operating System</h>: Robot Operating System (ROS) </p>
                        <p>
                            <h style={{ color: "#bcc4b7" }}>Software and Tools</h>: Stonefish, Gazebo, Rosbag, CodeBlocks, Emu8086, Cisco Packet Tracer, Visual Studio, Proteus Design Suite, LTSpice, AutoCAD, Adobe
                            Illustrator, Simulink, Microwind, DSCH, QUARTUS’Ⅱ</p>
                        <p>
                            <h style={{ color: "#bcc4b7" }}>Web Development</h>: HTML, CSS, JavaScript, React.js, Bootstrap</p>
                        <p>
                            <h style={{ color: "#bcc4b7" }}>Machine Learning</h>:
                            TensorFlow, Scikit-Learn, PyTorch</p>
                        <p>
                            <h style={{ color: "#bcc4b7" }}>App Development</h>:
                            Flutter, Android Studio</p>
                        <p>
                            <h style={{ color: "#bcc4b7" }}>Visualisation</h>:
                            Rviz, Plotjuggler, Matplotlib, Seaborn</p>
                            <p>
                            <h style={{ color: "#bcc4b7" }}>Hardware</h>: Arduino</p> <p>
                            <h style={{ color: "#bcc4b7" }}>Version Control</h>: Git</p>
                        <p>
                            <h style={{ color: "#bcc4b7" }}>Computer Vision</h>: MATLAB, OpenCV</p> */}
                        <div style={{ borderLeft: '2px solid #bcc4b7', padding: '10px' }}>
  <div style={{ marginLeft: '10px' }}>
    <h4 style={{ color: '#bcc4b7' }}>Programming Languages</h4>
    <p>Python, C, C++, MATLAB, JavaScript, Dart, LATEX, Verilog HDL</p>
  </div>
  
  <div style={{ marginLeft: '10px', marginTop: '10px' }}>
    <h4 style={{ color: '#bcc4b7' }}>Libraries</h4>
    <p>PyTorch, TensorFlow, OpenCV, Numpy, Pandas, Matplotlib</p>
  </div>
  
  <div style={{ marginLeft: '10px', marginTop: '10px' }}>
    <h4 style={{ color: '#bcc4b7' }}>Software and Tools</h4>
    <p>ROS, Stonefish, Gazebo, Docker, Pybullet, Plotjuggler, AutoCAD</p>
  </div>
  
  <div style={{ marginLeft: '10px', marginTop: '10px' }}>
    <h4 style={{ color: '#bcc4b7' }}>Web Development</h4>
    <p>HTML, CSS, React.js, Bootstrap</p>
  </div>
  
  <div style={{ marginLeft: '10px', marginTop: '10px' }}>
    <h4 style={{ color: '#bcc4b7' }}>App Development</h4>
    <p>Flutter, Android Studio</p>
  </div>

  <div style={{ marginLeft: '10px', marginTop: '10px' }}>
    <h4 style={{ color: '#bcc4b7' }}>Version Control</h4>
    <p>Git</p>
  </div>
</div>

<br/>
                        <h style={{ color: "#00FFFF"}}> <u>Selected Certifications:</u></h>
                        <ul>
                            <li>
                                Coursera on Fundamentals of Digital Image and Video Processing Certified by Northwestern University. <a style={{ color:"yellow"}}href="https://www.coursera.org/account/accomplishments/verify/JE5BXT6HBWYL?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course" target="_blank"><i>Link</i></a>
                            </li>
                            <li>
                                Coursera on Front-End Web UI Frameworks and Tools: Bootstrap 4 Certified by Hong Kong University Of
                                Science And Technology. <a style={{ color:"yellow"}}href="https://www.coursera.org/account/accomplishments/verify/P9QGGCGMB3DA?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course" target="_blank"><i>Link</i></a>
                            </li>
                            <li>
                                Coursera on Programming Foundations with JavaScript, HTML and CSS Certified by Duke University. <a style={{ color:"yellow"}}href="https://www.coursera.org/account/accomplishments/verify/8CT7BK7G9XQL?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course" target="_blank"><i>Link</i></a>
                            </li>
                            <li>
                                Coursera on Build Your Portfolio Website with HTML and CSS Certified by Coursera Project Network. <a style={{ color:"yellow"}}href="https://www.coursera.org/account/accomplishments/verify/R4MLRNUFTF96?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=project" target="_blank"><i>Link</i></a></li>
                            <li> Python Starter Pack Workshop Certified by MIST Innovation Club with support of e-learning partner ohubrihi
                                Online Courses. <a style={{ color:"yellow"}}href="https://drive.google.com/file/d/1yzZqckoRtcd7wrn8t3jVamlPieexWH5b/view" target="_blank"><i>Link</i></a>

                            </li>
                            <li>Coursera on Python Data Structures certified by Coursera Project Network. <a style={{ color:"yellow"}}href="https://www.coursera.org/account/accomplishments/verify/KBNXEBJPZ4R8?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=pdf_header_button&utm_product=project" target="_blank"><i>Link</i></a></li>
                            <li>Introduction to Flutter Development Using Dart Certified by The App Brewery. <a style={{ color:"yellow"}}href="https://drive.google.com/file/d/1ZZfxpIc_e7bz2sU8oW7-WfOyYXvl2Aq7/view" target="_blank"><i>Link</i></a></li>
                        </ul>

                    
<br/>


                    
                  <br/>  
                   <h className="tabs-list">Extracurricular Activities</h>
                     <ul>
                        <p style={{ color: "#00FFFF"}}>2025</p>
                        <li>Reviewer, Journal of Engineering Research and Reviews, served as a member of the Scientiﬁc Advisory Board and evaluated a manuscript in the domain of Internet of Things (IoT) and autonomous robotic systems.</li>
<br/>
                        <p style={{ color: "#00FFFF"}}>2021</p>
                        <li>Session Host, 5th International Conference on Electrical Engineering and Information & Communication Technology (ICEEICT), moderated three sessions, engaged with session chairs and participants, and managed Q&A.</li>
                        <li>Inauguration Committee Member, 5th International Conference on Electrical Engineering and Information & Communication Technology (ICEEICT), contributed to the organization and execution of the inauguration ceremony.</li>
<br/>
<p style={{ color: "#00FFFF"}}>2018</p>
                        <li>Volunteer, MIST ROBOFEST 2018, coordinated event logistics and assisted with technical setups, organized by MIST Robotics Club.</li>
</ul>
<br/>


                    
                  <br/>  
                    <h className="tabs-list">Awards & Honors</h>
                    <Row style={{marginTop:10}}>
                            <Col xs={1} md={1} lg={1}>
                            <img src= {EU} alt="EU" className="icon-about"/>
                            </Col>
                            <Col xs={11} md={11} lg={11}>
                            <p style={{marginRight:10}}> Awareded Erusmus Mundus Joint Masters Scholarship funded by European Union (EU), securing 12th place out of 958 applicants.</p>
                                </Col>
                        </Row>
                    <Row style={{marginTop:10}}>
                            <Col xs={1} md={1} lg={1}>
                            <img src= {Badge} alt="badge" className="icon-about"  />
                            </Col>
                            <Col xs={11} md={11} lg={11}>
                            <p style={{marginRight:10}}> Dean's List Award in 3rd year Issued by Military Institute of Science and Technology.</p>
                                </Col>
                        </Row>
                        <Row>
                            <Col xs={1} md={1} lg={1}>
                            <img src= {Badge1} alt="badge(1)" className="icon-about" />
                            </Col>
                            <Col xs={11} md={11} lg={11}>
                            <p style={{marginRight:10}} > Achieved 1st place in the long Python Starter Pack Workshop organized by MIST Innovation Club with support of
e-learning partner Bohubrihi Online Courses.</p>
                                </Col>
                        </Row>
                    
                </div>


            </Container>

<hr style={{color: "white", backgroundColor:"white", marginLeft: 15, marginRight: 15}}/>
<Resume/>
        </div>
    )
}
